var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spacer-w16-spacer-16",class:_vm.rootClassName})}
var staticRenderFns = []

export { render, staticRenderFns }